<template>
	<div class="HTage">
		<div v-if="isShowErr" class="error">
			<i class="icon el-icon-error" />
			<div class="content">您网站内没有设置H标签，搜索引擎可能难以准确地分析和索引页面</div>
		</div>
		<el-tabs type="border-card" v-else>
			<el-tab-pane v-for="(item, key) in data" :key="key" :label="`${key}(${item.length})`">
				<div v-if="item.length > 0" class="h_item">
					<p v-for="(_item, index) in item" :key="index">{{ _item }}</p>
				</div>
				<div v-else class="h_err">
					<p>您网站内没有{{ key }}标签</p>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
export default {
	name: 'HTage',
	props: ['data'],
	computed: {
		isShowErr(self) {
			let { data } = self;
			let status = true;
			Object.keys(data).forEach(key => {
				if (data[key].length > 0) status = false;
			});
			return status;
		},
	},
};
</script>

<style lang="scss" scoped>
.HTage {
	.error {
		display: flex;
		align-items: center;
		padding: 50px 20px;

		.icon {
			font-size: 25px;
		}

		.el-icon-success {
			color: #43b58e;
		}

		.el-icon-error {
			color: #ff0b0b;
		}

		.content {
			margin-left: 10px;
			color: #ff0b0b;
		}
	}

	::v-deep .el-tabs {
		width: 700px;
		margin: 20px 20px 20px 30px;

		.el-tabs__content {
			padding: 0px;
		}

		.h_item {
			height: 200px;
			overflow-y: auto;
			padding: 15px;
			// 改变滚动条样式
			&::-webkit-scrollbar {
				width: 5px;
			}

			&::-webkit-scrollbar-thumb {
				background-color: #d8d8d8;
				border-radius: 2px;
			}

			&::-webkit-scrollbar-track {
				background-color: #fff;
				border-radius: 2px;
			}

			p {
				margin: 2px 0;
				font-size: 16px;
				font-weight: 400;
				color: #333333;
			}
		}

		.h_err {
			height: 200px;
			padding: 15px;
			color: #ff0b0b;
		}
	}
}
</style>
